import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../misc';
import classNames from 'classnames';

const GDPRHint = ({ className, faceNote }) => {
  const linkToPrivacy = (
    <a href="/privacy" target="_blank" rel="noopener noreferrer">
      <FormattedMessageWrappedInSpan id="gdprHint.link" defaultMessage="privacy policy" />
    </a>
  );

  return (
    <div className={classNames('gdpr-hint-text', className)}>
      { faceNote && <FormattedMessageWrappedInSpan
	  id="gdprHint.face"
	  defaultMessage="The uploaded selfie will not be stored."
	/>
      }
      <FormattedMessageWrappedInSpan
        id="gdprHint.text"
        defaultMessage="I have read and accept the {link}, in particular Art. 4"
        values={{ link: linkToPrivacy }}
      />
    </div>
  );
};

GDPRHint.defaultProps = {
  faceNote: false
};

GDPRHint.propTypes = {
  className: PropTypes.string,
  faceNote: PropTypes.bool,
};

export default GDPRHint;
